var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleDocsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.942 0h-8.45A1.5 1.5 0 0 0 0 1.5v19A1.5 1.5 0 0 0 1.491 22h12.925a1.5 1.5 0 0 0 1.492-1.5V6L9.942 0Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.942 0h-8.45A1.5 1.5 0 0 0 0 1.5v19A1.5 1.5 0 0 0 1.491 22h12.925a1.5 1.5 0 0 0 1.492-1.5V6l-3.48-2.5L9.942 0Z",
    fill: "#4285F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.942 0h-8.45A1.5 1.5 0 0 0 0 1.5v19A1.5 1.5 0 0 0 1.491 22h12.925a1.5 1.5 0 0 0 1.492-1.5V6L9.942 0Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.379 5.56 5.53 5.56V6l-5.53-.44Z",
    fill: "url(#d)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 22
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.942 0h-8.45A1.5 1.5 0 0 0 0 1.5v19A1.5 1.5 0 0 0 1.491 22h12.925a1.5 1.5 0 0 0 1.492-1.5V6L9.942 0Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.977 16h7.953v-1H3.977v1Zm0 2h5.965v-1H3.977v1Zm0-7v1h7.953v-1H3.977Zm0 3h7.953v-1H3.977v1Z",
    fill: "#F1F1F1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 22
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.942 0h-8.45A1.5 1.5 0 0 0 0 1.5v19A1.5 1.5 0 0 0 1.491 22h12.925a1.5 1.5 0 0 0 1.492-1.5V6L9.942 0Z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.941 0v4.5c0 .829.668 1.5 1.492 1.5h4.474L9.94 0Z",
    fill: "#A1C2FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 22
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.942 0h-8.45A1.5 1.5 0 0 0 0 1.5v19A1.5 1.5 0 0 0 1.491 22h12.925a1.5 1.5 0 0 0 1.492-1.5V6L9.942 0Z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.491 0A1.5 1.5 0 0 0 0 1.5v.125a1.5 1.5 0 0 1 1.491-1.5h8.451V0h-8.45Z",
    fill: "#fff",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 22
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.942 0h-8.45A1.5 1.5 0 0 0 0 1.5v19A1.5 1.5 0 0 0 1.491 22h12.925a1.5 1.5 0 0 0 1.492-1.5V6L9.942 0Z",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.416 21.875H1.491A1.5 1.5 0 0 1 0 20.375v.125A1.5 1.5 0 0 0 1.491 22h12.925a1.5 1.5 0 0 0 1.492-1.5v-.125a1.5 1.5 0 0 1-1.492 1.5Z",
    fill: "#1A237E",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "i",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 22
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.942 0h-8.45A1.5 1.5 0 0 0 0 1.5v19A1.5 1.5 0 0 0 1.491 22h12.925a1.5 1.5 0 0 0 1.492-1.5V6L9.942 0Z",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.433 6A1.495 1.495 0 0 1 9.94 4.5v.125c0 .829.668 1.5 1.492 1.5h4.474V6h-4.474Z",
    fill: "#1A237E",
    fillOpacity: 0.1
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.942 0h-8.45A1.5 1.5 0 0 0 0 1.5v19A1.5 1.5 0 0 0 1.491 22h12.925a1.5 1.5 0 0 0 1.492-1.5V6L9.942 0Z",
    fill: "url(#j)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(.504 .435) scale(25.6509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 13.144,
    y1: 6.038,
    x2: 13.144,
    y2: 11.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A237E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A237E",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h15.908v22H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDocsIcon);
export default __webpack_public_path__ + "static/media/google-docs-icon.a6a9ced6560999b39954cd55570cfd03.svg";
export { ForwardRef as ReactComponent };